import customFeatureClient from './customFeatureClient';

export const candidateToCustomFeature = async (
  data,
  url,
  method = 'POST',
  authentication,
  headers
) => {
  try {
    const response = await customFeatureClient({
      url,
      method,
      data,
      headers: {
        ...(headers ?? {}),
        ...(authentication
          ? { Authorization: `${authentication.type} ${authentication.value}` }
          : {}),
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};
